module.exports = __webpack_public_path__ + "img/flow-step-3.6ce060a.png";